var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComma(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 154,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 538,
    y: 283,
    width: 204,
    height: 154
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-538 -283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.306 153.835 140.708 153.835C126.619 153.835 115.099 142.316 115.099 128.227 115.099 75.5337 101.64 17.6527 166.217 1.12712 195.473-6.34834 203.097 25.8741 171.985 28.0952 153.007 29.4543 149.294 41.7201 148.714 60.2513L178.069 60.2513C192.158 60.2513 203.677 71.7711 203.677 85.8601L203.677 127.448C203.677 141.968 191.809 153.835 177.306 153.835L177.306 153.835ZM63.3674 153.835 26.7691 153.835C12.6801 153.835 1.16027 142.316 1.16027 128.227 1.16027 75.5337-12.2989 17.6527 52.2785 1.12712 81.5505-6.36492 89.1752 25.8575 58.0467 28.0952 39.068 29.4543 35.3551 41.7201 34.775 60.2513L64.1465 60.2513C78.2355 60.2513 89.7553 71.7711 89.7553 85.8601L89.7553 127.448C89.7387 141.968 77.8708 153.835 63.3674 153.835L63.3674 153.835Z",
    fill: "#BBC1C9",
    fillRule: "evenodd",
    transform: "matrix(1.00158 0 0 1 538 283.082)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComma);
export default __webpack_public_path__ + "static/media/comma.0df2b728118a773cf458f82bb30c5010.svg";
export { ForwardRef as ReactComponent };